/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import AppNavPills from "../../common/AppNavPills";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import Table from "../../common/Table";
import Body from "../../components/Body";
import expenseNavs from "../../components/expenseNavs";
import moment from "moment";
import api from "../../config/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getExpenseCategories } from "../../stores/ExpenseCategoryStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const header = [
  { title: "Date", name: "date" },
  { title: "Category", name: "category" },
];

const formInit = {
  category: "",
  date: new Date().toISOString(),
};
export default function ExpensesSettings() {
  const navigate = useNavigate();
  const [form, setForm] = useState(cloneDeep(formInit));
  const queryClient = useQueryClient();

  const { data: list } = useQuery({
    queryFn: () => getExpenseCategories(),
    queryKey: ["expenseCategory"],
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    const res = await api.post("expenseCategory", form);
    if (!res.ok) return toast.error(res.originalError.message);
    setForm(formInit);
    queryClient.invalidateQueries(["expenseCategory"]);
    toast.success("Category has been successfully added.");
  };
  const handleChange = ({ currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    setForm({ ...form, [name]: value });
  };
  return (
    <Body
      title="Expenses"
      topRight={
        <AppButton
          onClick={() => {
            navigate("/expenses/paySalary");
          }}
          text="Pay Salary"
          className="btn-warning"
        />
      }
    >
      <div>
        <div style={{ margin: "0px 20px 20px 20px" }}>
          <AppNavPills list={expenseNavs} />
        </div>
        <form onSubmit={handleSubmit}>
          <div>
            <DetailBlock style={{ width: 800 }}>
              <LabelInput
                name="category"
                onChange={handleChange}
                label="Category"
                required
                value={form.category}
              />
            </DetailBlock>
            <DetailBlock
              style={{
                width: 800,
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <AppButton
                type="submit"
                text="Create"
                style={{ margin: "10px 0px" }}
                className="btn-primary"
              />
            </DetailBlock>
          </div>
        </form>

        <br />
        <br />
        {list?.length > 0 && (
          <Table
            header={header}
            data={list.map((i) => {
              return { ...i, date: moment(i.date).format("DD/MM/YYYY") };
            })}
          />
        )}
      </div>
    </Body>
  );
}
